import Products, {model as ProductsModel} from './products'
import Props, {model as PropsModel} from './prop'
import Orders, {model as OrdersModel} from './orders'
import Catalogues, {model as CataloguesModel} from './catalogues'
import Clients, {model as ClientsModel} from './clients'
import InventoryLocations, {model as InventoryLocationsModel} from './inventory-locations'
import StorageLocations, {model as StorageLocationsModel} from './storage-locations'
import StorageTypes, {model as StorageTypeModel} from './storage-type'
import Packing, {model as PackingModel} from './packing'
import Invoices, {model as InvoicesModel} from './invoices'
import StockItems, {model as StockItemsModel} from './stock-items'
import StockLedger, {model as StockLedgerModel} from './stock-ledger'
import CatalogueProducts, {model as CatalogueProductsModel} from './catalogue-products'
import Imports, {model as ImportsModel} from './imports'
import Datamap, {model as DatamapModel} from './datamap'
import Categories, {model as CategoriesModel} from './categories'
import Supplier, {model as SupplierModel} from './supplier'
import SupplierCatalogue, {model as SupplierCatalogueModel} from './supplier-catalogue'
import CatalogueStockItem, {model as CatalogueStockItemModel} from './catalogue-stock-item'
import SourceOrder, { model as SourceOrderModel } from './source-order'
import { ContentType } from '@/services/directr'

export const models = {
  [ContentType.Prop]: PropsModel,
  [ContentType.Order]: OrdersModel,
  [ContentType.Product]: ProductsModel,
  [ContentType.Catalogue]: CataloguesModel,
  [ContentType.Client]: ClientsModel,
  [ContentType.InventoryLocation]: InventoryLocationsModel,
  [ContentType.StorageLocation]: StorageLocationsModel,
  [ContentType.StorageType]: StorageTypeModel,
  [ContentType.Packing]: PackingModel,
  [ContentType.Invoice]: InvoicesModel,
  [ContentType.StockItem]: StockItemsModel,
  [ContentType.StockLedger]: StockLedgerModel,
  [ContentType.CatalogueProduct]: CatalogueProductsModel,
  [ContentType.Import]: ImportsModel,
  [ContentType.Datamap]: DatamapModel,
  [ContentType.Category]: CategoriesModel,
  [ContentType.Supplier]: SupplierModel,
  [ContentType.SupplierCatalogue]: SupplierCatalogueModel,
  [ContentType.CatalogueStockItem]: CatalogueStockItemModel,
  [ContentType.SourceOrder]: SourceOrderModel

}

const modules = {
  Orders,
  Products,
  Props,
  Catalogues,
  Clients,
  InventoryLocations,
  StorageLocations,
  StorageTypes,
  Packing,
  Invoices,
  StockItems,
  StockLedger,
  CatalogueProducts,
  Imports,
  Datamap,
  Categories,
  Supplier,
  SupplierCatalogue,
  CatalogueStockItem,
  SourceOrder
}

export default modules

export const ContentModuleNames = Object.keys(modules)
